import styled from 'styled-components';

export const Container = styled.div`
  background-color: #ffeff0;
  border: 1px #eb2026 solid;
  border-radius: 4px;
  padding: 24px;
  h4 {
    font-size: 16px;
    line-height: 24px;
    font-weight: 900;
    color: #eb2026;
    margin-bottom: 6px;
  }
  ul li {
    font-size: 16px;
    line-height: 24px;
    color: #eb2026;
    position: relative;
    margin-bottom: 8px;
  }
`;
